import { queryOptions, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap, type ApiClient } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type NavCounts = components['schemas']['NavCounts'];

/** The sidebar's pending counts. Invalidate queryKeys.navCounts() after an upload or a clear. */
export function navCountsQuery(api: ApiClient) {
  return queryOptions({
    queryKey: queryKeys.navCounts(),
    queryFn: () => unwrap(api.GET('/api/nav/counts')),
  });
}

export function useNavCounts() {
  return useQuery(navCountsQuery(useApiClient()));
}
